import tableRelatedDevice from './tableRelatedDevice';

export default {
  attributeName: 'deviceId',
  title: 'List of Devices',
  getURL: 'devices',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemId: 'deviceId',
  itemName: ['tags', 'inventoryId'],
  sessionParams: [],
  tableConfig: tableRelatedDevice,
  dialogClassName:'modal-60w', 
};